import { env } from "$env/dynamic/public";

export default {
  SHOPIFY_STORE: env.BS_SHOPIFY_STORE || "belstaff-global",
  SHOPIFY_ENDPOINT:
    env.BS_SHOPIFY_ENDPOINT ||
    `https://${env.BS_SHOPIFY_STORE}.myshopify.com/api/2023-04/graphql.json`,
  SHOPIFY_ADMIN_ENDPOINT:
    env.BS_SHOPIFY_ADMIN_ENDPOINT ||
    `https://${env.BS_SHOPIFY_STORE}.myshopify.com/admin/api/2023-04/graphql.json`,
  SHOPIFY_ACCESS_TOKEN: env.BS_SHOPIFY_ACCESS_TOKEN,
  CMS_ENDPOINT: env.BS_CMS_ENDPOINT || "cms.dev.belstaff.soon.build",
  NOSTO_ENDPOINT: env.BS_NOSTO_ENDPOINT,
  NOSTO_ACCOUNT_ID: env.BS_NOSTO_ACCOUNT_ID,
  NOSTO_SEARCH_ENDPOINT: env.BS_NOSTO_SEARCH_ENDPOINT,
  NOSTO_SEARCH_API_KEY: env.NOSTO_SEARCH_API_KEY,
  NOSTO_API_KEY: env.BS_NOSTO_API_KEY,
  CMS_INTERNAL_ENDPOINT: env.BS_CMS_INTERNAL_ENDPOINT,
  FETCHIFY_ACCESS_TOKEN: env.BS_FETCHIFY_ACCESS_TOKEN,
  REGION_ID: env.BS_REGION_ID || "staging",
  GTM_ID: env.BS_GTM_ID,
  DEFAULT_LOCALE: env.BS_DEFAULT_LOCALE,
  CURRENCY_LOCALE: env.BS_CURRENCY_LOCALE || "en-GB",
  OT_ID: env.BS_OT_ID,
  BASE_PATH: env.BS_BASE_PATH,
  LANGS: env.BS_LANGS?.split(",") || ["en", "fr", "it", "de", "es"],
  KLARNA_SUBDOMAIN: env.BS_KLARNA_SUBDOMAIN,
  KLARNA_CLIENT_ID: env.BS_KLARNA_CLIENT_ID,
  KLARNA_SHOW_BANNERS: env.BS_KLARNA_SHOW_BANNERS,
  SENTRY_DSN: env.BS_SENTRY_DSN || "fa869ed905414a6d9eee4ef448dda94b@o1080904",
  SENTRY_PROJECT_ID: env.BS_SENTRY_PROJECT_ID || "6087640",
  SENTRY_ENV: env.BS_SENTRY_ENV || "development",
  SENTRY_TRACE_SAMPLERATE: parseFloat(env.BS_SENTRY_TRACE_SAMPLERATE) || 0,
  PAGE_HOME: env.BS_PAGE_HOME || "da1a0c73-c8d3-4596-a983-64df51075bcf",
  PAGE_SUSTAINABILITY:
    env.BS_PAGE_SUSTAINABILITY || "8561a786-e6f5-462e-be18-c90e7727b914",
  PAGE_LOYALTY: env.BS_PAGE_LOYALTY || "0aa6844a-0ee4-4d6e-9f52-5809cca61a62",
  SEARCH_ENABLED: env.BS_SEARCH_ENABLED || false,
  ZENDESK_ENDPOINT: env.BS_ZENDESK_ENDPOINT,
  BACK_IN_STOCK: env.BS_BACK_IN_STOCK,
  NOSTO_SHOW_RECS: env.BS_NOSTO_SHOW_RECS,
  VOYADO_TRACKING_ENABLED: env.BS_VOYADO_TRACKING_ENABLED,
  VOYADO_ENV: env.BS_VOYADO_ENV,
  VOYADO_LOCALE_ROW: env.BS_VOYADO_LOCALE_ROW,
  VOYADO_LOCALE_UK: env.BS_VOYADO_LOCALE_UK,
  VOYADO_LOCALE_US: env.BS_VOYADO_LOCALE_US,
  VOYADO_LOCALE_DE_DE: env.BS_VOYADO_LOCALE_DE_DE,
  VOYADO_LOCALE_DE_EN: env.BS_VOYADO_LOCALE_DE_EN,
  VOYADO_LOCALE_EU_EN: env.BS_VOYADO_LOCALE_EU_EN,
  VOYADO_LOCALE_EU_DE: env.BS_VOYADO_LOCALE_EU_DE,
  VOYADO_LOCALE_EU_ES: env.BS_VOYADO_LOCALE_EU_ES,
  VOYADO_LOCALE_EU_IT: env.BS_VOYADO_LOCALE_EU_IT,
  VOYADO_LOCALE_EU_FR: env.BS_VOYADO_LOCALE_EU_FR,
  VOYADO_LOCALE: env.BS_VOYADO_LOCALE,
  AB_TASTY_ENABLED: env.BS_AB_TASTY_ENABLED,
  ADMIN_HOST: env.BS_ADMIN_HOST || "admin.dev.belstaff.soon.build",
  PAGE_ABOUT_US: env.BS_PAGE_ABOUT_US || "54f06189-5925-4858-903f-4bc9efa43fc4",
  PAGE_ABOUT_US_TIMELINE:
    env.BS_PAGE_ABOUT_US_TIMELINE || "5f8b9cba-dd16-4a7b-a8ba-57655d830eaa",
  HOME_PAGE_DASH_SOCIAL: env.BS_HOME_PAGE_DASH_SOCIAL,
  PUBLIC_CLOUDINARY_CLOUD_NAME: env.BS_PUBLIC_CLOUDINARY_CLOUD_NAME,
};
